import styled from 'styled-components'
import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'

const CardStatisticStyled = styled.div`

  /* Tarjeta compacta: 16 px de padding y sin alto mínimo (antes 20 px y 90-114 px de alto) */
  .card-container {
    align-items: center;
    row-gap: 8px;
    background-color: ${colors.white};
    padding: 16px;
    min-width: 200px;
    box-shadow: 0px 4px 6px rgba(98, 102, 113, 0.06), 0px 2px 2px rgba(98, 102, 113, 0.06);
    border-radius: 6px; 
  }

  /* Etiqueta 14/500 en gris y cifra 20/600 (antes 18/700 y 40 en negrita) */
  .label-stat {
      text-align: left;
      font-weight: 500;
      font-size: 14px !important;
      line-height: 20px;
      color: ${tokens.color.text.secondary};
      margin: 0;
      display: inline-block;
      align-self: center;
  }

  .value-stat {
    font-weight: 600;
    font-size: ${props => props.smallText ? '16px' : '20px'};
    line-height: 28px;
    text-align: right;
    color: ${tokens.color.text.primary};
    display: inline-block;
    align-self: center;
  }

`

export default CardStatisticStyled
